import * as actionTypes from "./actionTypes";
import * as apiCall from "../services/api";
import { API_BASE_URL } from "../config/apiConfig";


export const getParticipanetsListSuccess = (data) => {
  return {
    type: actionTypes.GET_PARTICIPANETS_LIST,
    payload: {
      participanets: data.Data,
    },
  };
};

export const getParticipanetsList = (data) => async (dispatch) => {
  return await apiCall
    .axiosPost(`${API_BASE_URL}/GetParticipanetsList`, data)
    .then((response) => {
      if (response) {
        dispatch(getParticipanetsListSuccess(response.data));
      }
    })
    .catch((error) => {
      console.log('Error: ', error);
    });
};
